const ONECLICK_STYLE_ID = "oneclick-loader-style";

const ONECLICK_STYLE_CONTENT = `
html.oneclick-loading::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 10000;
}

html.oneclick-loading::after {
  content: "";
  position: fixed;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  margin: -25px 0 0 -25px;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #555;
  -webkit-animation: oneclick-loader-spin 2s linear infinite;
  animation: oneclick-loader-spin 2s linear infinite;
  z-index: 10001;
}

@-webkit-keyframes oneclick-loader-spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes oneclick-loader-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
`;

export default class OneClickLoader {
  static ensureStyle() {
    if (document.getElementById(ONECLICK_STYLE_ID)) {
      return;
    }

    const style = document.createElement("style");
    style.id = ONECLICK_STYLE_ID;
    style.textContent = ONECLICK_STYLE_CONTENT;
    document.head.appendChild(style);
  }

  static start() {
    this.ensureStyle();
    document.documentElement.classList.add("oneclick-loading");
  }

  static stop() {
    document.documentElement.classList.remove("oneclick-loading");
  }
}
